import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import MicrofonoList from "../List/MicrofonoList"
import SonidoList from "../List/SonidoList"
import CamaraList from "../List/CamaraList"
import RedList from "../List/RedList"

import Button from '@mui/material/Button';

const Step6 = forwardRef((props, ref) => {
  const [contenidoResumen, setContenidoResumen] = React.useState("");
  const [enlaceCopiado, setEnlaceCopiado] = React.useState(false);

  const init = () => {
    if (props.accesoMicrofono && props.funcionamientoMicrofono && props.funcionamientoSonido && props.accesoCamara && 
        props.funcionamientoCamara && props.resolucionesCamara && props.senializacion && props.retransmision) {
        setContenidoResumen("¡Felicitaciones! Ya tenés todo listo para tener tu videoconsulta. Recomendamos cerrar esta pestaña.");
      } else {
        setContenidoResumen("Lamentablemente encontramos algunos problemas.");
      }
  }

  function jsonToBase64UrlSafe(jsonObj) {
    const jsonString = JSON.stringify(jsonObj);
    const base64String = btoa(jsonString);
    const base64UrlSafeString = base64String
        .replace(/\+/g, '-')  // Reemplaza '+' con '-'
        .replace(/\//g, '_')  // Reemplaza '/' con '_'
        .replace(/=+$/, '');  // Elimina cualquier '=' al final
    return base64UrlSafeString;
  }

  const generateLink = () => {
    const base64 = jsonToBase64UrlSafe(props);
    let linkToShareInput = document.getElementById("link-to-share-input");
    const linkToShare = "https://www.hospitalvirtual.com.ar/test-compatibilidad/?result=" + base64;
    linkToShareInput.value = linkToShare;
    return linkToShare
  }

  const copyLink = () => {
    let linkToShareInput = document.getElementById("link-to-share-input");
    linkToShareInput.select();
    linkToShareInput.setSelectionRange(0, 99999); // Para móviles
    navigator.clipboard.writeText(linkToShareInput.value);
    setEnlaceCopiado(true);
  }

  const share = async () => {
    const linkToShare = generateLink();
    if (navigator.share) {
      try {
        await navigator.share({
            title: 'Tests - Hospital Virtual',
            text: 'En el siguiente link están los resultados de los tests para tener una videoconsulta óptima:',
            url: linkToShare
        });
      } catch (error) {
        copyLink();
      }
    } else {
      copyLink();
    }
  }

  const restart = () => {
    props.restart();
  }

  React.useEffect(() => {
    init();
  }, []);

  return (
    <div style={{ minHeight: "70vh" }}>
      <h2>Resumen final</h2>
      <p style={{ textAlign: 'left', margin: '20px' }}>
        {contenidoResumen}
      </p>
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <Button variant="outlined" color="primary" onClick={restart}>
            Repetir
        </Button>
        <Button variant="outlined" color="primary" style={{ marginLeft: "10px" }} onClick={share}>
            Compartir
        </Button>
        {enlaceCopiado? <div style={{ margin: "10px", fontWeight: "bold", fontSize: "22px"}}>¡Enlace copiado!</div>: "" }
        <input type="text" id="link-to-share-input" style={{ display: "none" }} />
      </div>
      <p variant="outlined" style={{ textAlign: 'left', fontSize: '14px', margin: '20px' }}>
        Si necesitás ayuda, no dudes en contactarnos por nuestros canales de atención al cliente.
      </p>
      <div style={{ textAlign: 'center'}}>
        <MicrofonoList title="Micrófono" acceso={props.accesoMicrofono} funcionamiento={props.funcionamientoMicrofono} />
        <SonidoList title="Sonido" funcionamiento={props.funcionamientoSonido} />
        <CamaraList title="Cámara" acceso={props.accesoCamara} funcionamiento={props.funcionamientoCamara}
        resolucionesCamara={props.resolucionesCamara} resolucionQVGACamara={props.resolucionQVGACamara}
        resolucionVGACamara={props.resolucionVGACamara} resolucionHDCamara={props.resolucionHDCamara}
        resolucionFullHDCamara={props.resolucionFullHDCamara} resolucion2kCamara={props.resolucion2kCamara}
        resolucion4kCamara={props.resolucion4kCamara}
        />
        <RedList title="Red" senializacion={props.senializacion} retransmision={props.retransmision} />
      </div>
    </div>
  );
});

export default Step6;